/**
 * Trestlethorn — Recently Viewed Products
 * Tracks product views in localStorage, renders a card grid on demand.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'tt_recently_viewed';
  var MAX_ITEMS = 8;

  /* ── Helpers ─────────────────────────────────────────────── */

  function getItems() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveItems(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) { /* storage full or private mode */ }
  }

  function formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    var amount = (cents / 100).toFixed(2);
    // Strip trailing .00
    return '$' + amount.replace(/\.00$/, '');
  }

  /* ── Save current product ────────────────────────────────── */

  function saveCurrentProduct() {
    var dataEl = document.getElementById('tt-rv-data');
    if (!dataEl) return;

    var product;
    try {
      product = JSON.parse(dataEl.textContent);
    } catch (e) { return; }

    if (!product || !product.handle) return;

    var items = getItems();
    // Remove existing entry for this product (de-dupe)
    items = items.filter(function (p) { return p.handle !== product.handle; });
    // Prepend current product
    items.unshift(product);
    // Trim to max
    items = items.slice(0, MAX_ITEMS);
    saveItems(items);
  }

  /* ── Card HTML builder ───────────────────────────────────── */

  function cdnUrl(url, width) {
    if (!url) return url;
    var sep = url.indexOf('?') !== -1 ? '&' : '?';
    return url + sep + 'width=' + width + '&format=webp';
  }

  function buildCard(product) {
    var hasCompare = product.compare_at_price && product.compare_at_price > product.price;
    var priceClass = hasCompare ? 'price--on-sale' : '';
    var imgHtml = product.image
      ? '<img src="' + cdnUrl(product.image, 400) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="400" height="400">'
      : '';

    return [
      '<li class="grid__item">',
        '<div class="card-wrapper product-card-wrapper underline-links-hover">',
          '<div class="card card--standard card--media card--extend-height">',
            '<div class="card__inner ratio" style="--ratio-percent: 100%;">',
              '<div class="card__media">',
                '<div class="media media--transparent">',
                  imgHtml,
                '</div>',
              '</div>',
              '<div class="card__content">',
                '<div class="card__badge bottom"></div>',
              '</div>',
            '</div>',
            '<div class="card__content">',
              '<div class="card__information">',
                '<h3 class="card__heading h5">',
                  '<a href="' + product.url + '" class="full-unstyled-link">',
                    escapeHtml(product.title),
                  '</a>',
                '</h3>',
                '<div class="card-information">',
                  '<div class="price ' + priceClass + '">',
                    hasCompare
                      ? '<div class="price__compare"><s class="price-item price-item--regular">' + formatMoney(product.compare_at_price) + '</s></div>'
                      : '',
                    '<div class="price__regular">',
                      '<span class="price-item price-item--' + (hasCompare ? 'sale' : 'regular') + '">',
                        formatMoney(product.price),
                      '</span>',
                    '</div>',
                  '</div>',
                '</div>',
              '</div>',
            '</div>',
          '</div>',
        '</div>',
      '</li>'
    ].join('');
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── Render section ──────────────────────────────────────── */

  function renderSection() {
    var container = document.getElementById('tt-rv-container');
    if (!container) return;

    var currentHandle = container.dataset.currentHandle || '';
    var items = getItems().filter(function (p) {
      return p.handle !== currentHandle;
    });

    if (!items.length) {
      // Hide the whole section if nothing to show
      var section = container.closest('.shopify-section') || container.closest('.tt-recently-viewed');
      if (section) section.style.display = 'none';
      return;
    }

    container.innerHTML = items.map(buildCard).join('');
  }

  /* ── Init ────────────────────────────────────────────────── */

  document.addEventListener('DOMContentLoaded', function () {
    saveCurrentProduct();
    renderSection();
  });
})();
